// composables/useRoles.ts
import type { UserRole } from '~/types/auth'

export function useRoles() {
  const authStore = useAuthStore()

  const roles = computed<string[]>(() => authStore.allRoles ?? [])

  function hasRole(target: string): boolean {
    return authStore.hasRole(target as UserRole)
  }

  function hasAnyRole(targets: string[]): boolean {
    return targets.some(hasRole)
  }

  return { roles, hasRole, hasAnyRole }
}
